module.exports = __webpack_public_path__ + "slapFace.61d05e10.png";